import { Link } from '../link';
import style from './style.module.css';

const Footer = () => {
  return (
    <div class={style.footer}>
      ©&nbsp;{new Date().getFullYear()} Zeppelin&nbsp;Techologies&nbsp;LLC&ensp;|&ensp;
      <Link href="/terms-of-use" class="underline">
        Terms
      </Link>
      &ensp;|&ensp;
      <Link href="/privacy-policy" class="underline">
        Privacy&nbsp;Policy
      </Link>
      &ensp;|&ensp;
      <Link href="/attribution" class="underline">
        Attribution
      </Link>
    </div>
  );
};

export default Footer;
